import React, { useEffect, useState } from "react";
import { Form, message, Checkbox, InputNumber, Skeleton, Row, Col } from "antd";
import { SelectWithSearch, SaveButton, InputText, CancelButton, ModalComponent, trans } from "@comps/components"
import { makeRequest, makeRequestStateless, getErrorProps } from "@utils/helpers";
import { createSelectList } from "@comps/commonFunctions";
import { updateDepartmentReq, getHodsByCompanyIdReq, getIdentifierReq } from "../requests";
import { Commons, Const } from "../../constants";

const langKey = Const["department"].lngKey
const formName = "updateDepartment";

const UpdateDepartment = (props) => {
  const [form] = Form.useForm()
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState([]);
  const [identifiers, setIdentifiers] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [limitHeadCount, setLimitHeadCount] = useState(false)
  const [hods, setHods] = useState([])
  const [saving, setsaving] = useState(false);
  const [loading, setloading] = useState(true);

  useEffect(() => {
    setCompaniesAndIdentifiers()
    setFormData()
    // eslint-disable-next-line
  }, []);


  const setCompaniesAndIdentifiers = () => {
    if (!props.departments) {
      return
    }

    setLimitHeadCount(props.record.has_limit)
    getHodByCompanyId(props.record.company_id)
    setDepartments(createSelectList(props.departments))
    makeRequestStateless(getIdentifierReq, false, onIdentifierSuccess, onIdentifierError)

  }

  const onIdentifierSuccess = (data) => {
    setloading(false)
    setIdentifiers(createSelectList(data))
  }

  const onIdentifierError = () => {
    message.error("Error while getting Identifiers")
  }

  const setFormData = (params) => {
    if (!props.record) {
      return
    }
    setLimitHeadCount(props.record.has_limit)
    form.setFieldsValue({
      name: props.record.name,
      code: props.record.code,
      identifier: props.record.identifier_id,
      parentDept: props.record.parent_id ?? props.record.parent_id,
      hod: props.record.hod_id,
      currentHeadCount: props.record.current_head_count,
      hasLimit: props.record.has_limit,
      maxHeadCount: props.record.max_head_count,
    })
  }

  const onSubmit = (data) => {

    setsaving(true)
    if (data.hasLimit === undefined || !data.hasLimit) {
      data.maxHeadCount = null
    }
    const payload = { id: props.record.id, name: data.name, has_limit: data.hasLimit, max_head_count: data.maxHeadCount, parent_id: data.parentDept, identifier_id: data.identifier === undefined ? null : data.identifier, hod_id: data.hod === undefined ? null : data.hod, }
    makeRequest(setLoader, updateDepartmentReq, payload, onSuccess, onError);
  }

  const onSuccess = (data, res) => {
    message.success("Department Updated successfully");
    props.onCompleted(data.departments.data);
  }

  const onError = (err, res) => {
    setsaving(false)
    message.error(res.response.data.message);
    //setErrors(errorList);
  }

  const getHodByCompanyId = (companyId) => {
    if (!companyId) {
      return
    }
    const payload = new FormData()
    payload.append("company_id", companyId)
    makeRequestStateless(getHodsByCompanyIdReq, payload, onHodsSuccess, onHodsError)
  }

  const onHodsSuccess = (res) => {
    setHods(createSelectList(res.hods))
  }

  const onHodsError = () => {
    message.error("Error while getting Hods By Company Id")
  }

  const handleLimitHeadCount = (e) => {
    setLimitHeadCount(e.target.checked)
  }

  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------

  const footer = [
    props.disabled ? '' :
      <SaveButton loading={ saving } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];

  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------

  return (
    <ModalComponent width={ 1000 } top={ 20 } maskClosable={ false }
      mainTitle={ trans(Commons[props.disabled ? 'view' : 'update']) } subTitle={ trans(`${langKey}.department`) }
      open={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>

      <Skeleton loading={ loading }>
        <Form form={ form } { ...formLayout } layout="vertical" name={ formName } onFinish={ onSubmit } disabled={ props.disabled }>
          <Row gutter={ 30 }>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="code" rules={ rules.name } label={ trans(Commons.code) }
                className="da-mb-16"
                { ...getErrorProps(errors['name']) } size="small"
              >
                <InputText disabled />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="name" rules={ rules.name } label={ trans(`${langKey}.name`) }
                className="da-mb-16"
                { ...getErrorProps(errors['name']) } size="small"
              >
                <InputText placeholder={ trans(`${langKey}.name`) } />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="parentDept" label={ trans(`${langKey}.parentDepartment`) }
                { ...getErrorProps(errors['parentDept']) }>
                <SelectWithSearch
                  className="da-mb-16"
                  placeholder={ trans(`${langKey}.selectParentDepartment`) }
                  options={ departments }
                />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="identifier" label={ trans(`${langKey}.identifier`) }
                className="da-mb-16"
                { ...getErrorProps(errors['identifier']) }>
                <SelectWithSearch
                  className="da-mb-16"
                  placeholder={ trans(`${langKey}.selectIdentifier`) }
                  options={ identifiers } />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="currentHeadCount" rules={ rules.currentHeadCount } label={ trans(`${langKey}.currentHeadCount`) }
                className="da-mb-16"
                { ...getErrorProps(errors['currentHeadCount']) } size="small"
              >
                <InputText disabled />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="hod" label={ trans(`${langKey}.hod`) }
                className="da-mb-16"
                { ...getErrorProps(errors['hod']) }>
                <SelectWithSearch
                  className="da-mb-16"
                  placeholder={ trans(`${langKey}.selectHod`) }
                  options={ hods } />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item valuePropName="checked" name="hasLimit" label={ trans(`${langKey}.hasLimit`) }
                className="da-mb-16" size="small"
              >
                <Checkbox checked={ limitHeadCount } value={ limitHeadCount } onChange={ handleLimitHeadCount } ></Checkbox>
              </Form.Item>
              {
                limitHeadCount ? <Form.Item name="maxHeadCount" rules={ rules.maxHeadCount } label={ trans(`${langKey}.maxHeadCount`) }
                  className="da-mb-16"
                  { ...getErrorProps(errors['maxHeadCount']) } size="small">
                  < InputNumber />
                </Form.Item> : null
              }
            </Col>
          </Row>
        </Form>
      </Skeleton>

    </ModalComponent>
  )
}

export default UpdateDepartment

const rules = {
  name: [
    { required: true, message: trans(`${langKey}.name.required`) },
  ],
  maxHeadCount: [
    { required: true, message: trans(`${langKey}.maxHeadCount.required`) },
  ],
  currentHeadCount: [
    { required: true, message: trans(`${langKey}.currentHeadCount`) },
  ],
};

const formLayout = {
  labelCol: { span: 6 },
  // wrapperCol: { span: 14, offset: 2 },
  labelAlign: "left"
}